exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/tables/tables.component.css
// module id = ../../../../../src/app/tables/tables.component.css
// module chunks = main